export const SET_APPOINTMENT_METADATA = 'SET_APPOINTMENT_METADATA';
export const CLEAR_APPOINTMENTS = 'CLEAR_APPOINTMENTS';

export interface SetAppointmentAction {
  type: typeof SET_APPOINTMENT_METADATA;
  payload: any;
}

export interface ClearAppointmentsAction {
  type: typeof CLEAR_APPOINTMENTS;
}

export type UserActionTypes = SetAppointmentAction | ClearAppointmentsAction;
